import { GET_LAPORAN_KEUANGAN, SET_LOADING_LAPORAN_KEUANGAN, SET_PAGINATION_LAPORAN_KEUANGAN } from '../constant';

const initialState = {
  laporanKeuangan: [],
  laporanKeuanganPagination: 0,
  loadingLaporanKeuangan: false,
  totalLaporanKeuangan: 0,
};

const laporanKeuanganReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_LAPORAN_KEUANGAN: {
      return {
        ...state,
        loadingLaporanKeuangan: action?.payload,
      };
    }
    case SET_PAGINATION_LAPORAN_KEUANGAN: {
      return {
        ...state,
        laporanKeuanganPagination: action?.payload,
      };
    }
    case GET_LAPORAN_KEUANGAN: {
      return {
        ...state,
        laporanKeuangan: action?.payload?.data || [],
        totalLaporanKeuangan: action?.payload?.total,
        loadingLaporanKeuangan: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default laporanKeuanganReducer;
